<template>
  <div class="contact">
    <el-row :gutter="20" style="margin:0;">
      <el-col :span="7" :offset="5" >
         <div class="contact-head">
             <div class="contact-head-left">
                 <dl>
                  <dt><img src="../assets/img/icon_yewuzixun.png" alt=""></dt>
                  <dd>业务咨询</dd>
                 </dl>
             </div>
             <div class="contact-head-right">
              13671131190
             </div>
         </div>
    </el-col>
    <el-col :span="7">
      <div class="contact-head">
             <div class="contact-head-left">
                 <dl>
                  <dt><img src="../assets/img/shangwuhezuo.png" alt=""></dt>
                  <dd>商务合作</dd>
                 </dl>
             </div>
             <div class="contact-head-right">
              010-62488802
             </div>
         </div>
      </el-col>
  </el-row>


  <el-row :gutter="0" style="margin:0;">
      <el-col :span="14" :offset="5" >

    <el-row :gutter="20" style="margin:0;" >
      <el-col :span="12"  v-for="(item,index) in lngs" :key="index" >
        <div class="contact-icon" @click="spansClick(item,index)">
        <span>{{item.span}}</span>
        <li><img src="../assets/img/dizhi.png" alt=""> <p>{{item.icon}}</p></li>
        <li @click.stop='sendEmail(item.email)'><img src="../assets/img/youxiang.png" alt=""> <p>{{item.email}} </p></li>
        <li @click.stop='sendphone(item.phone)'><img src="../assets/img/dianhua.png" alt=""> <p> {{item.phone}}</p></li>
    </div>

       </el-col>
  </el-row>




      </el-col>
  </el-row>




    <el-row :gutter="20" style="margin:0;margin-top:50px;">
      <el-col :span="14" :offset="5" >
        <baidu-map class="map" :center="{lng: lngs[id].lng, lat: lngs[id].lat}" style="width:100%;height:500px" :zoom="19">
     <bm-marker :position="{lng: lngs[id].lng, lat: lngs[id].lat}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
      <bm-label :content="lngs[id].text" :labelStyle="{color: 'white', fontSize : '16px',background:'#0152a1',border:0}" :offset="{width: -120, height: -50}"/>
    </bm-marker>
  </baidu-map>
  </el-col></el-row>

  <p class="contact-head-p" ref='lys'>
      ADVISORY MESSAGE
      <b>留言咨询</b>
    </p>

    <el-row :gutter="40" style="margin:0;">
      <el-col :span="14" :offset="5" >
         <div class="contact-message">
             <div class="contact-message-left">
              <el-input v-model="name" style="margin-bottom:10px;" placeholder="您的名字"></el-input>
              <el-input v-model="phone" style="margin-bottom:10px;" placeholder="您的手机"></el-input>
              <el-input v-model="input" placeholder="您的企业名称"></el-input>
             </div>
             <div class="contact-message-right">
              <el-input
                style="height:100%;"
                type="textarea"
                placeholder="您的留言咨询"
                v-model="textarea">
              </el-input>
            </div>
         </div>
    </el-col>
  </el-row>
  <el-row :gutter="40" style="margin:0;">
      <el-col :span="14" :offset="5" >
        <div class="contact-botton " >
         <span @click="addmessage" style="cursor: pointer;" >提交</span>
        </div>
      </el-col>
  </el-row>

  </div>
</template>

<script>
import lxapi from '../api/api'

export default {
  name: "contact",
  props: {

  },
  data() {
    return {
      id:0,
      lngs:[
      {
        text:'十方星链（苏州）航天科技有限公司',
        lng:'120.634474',
        lat:'31.431651',
        span:'苏州',
        phone:'010-62488895',
        email:'sfsatlink@sfsatlink.com',
        icon:'江苏省苏州市相城区青龙港路286号长三角研发启动区10号楼H门1222室',
      },
      {
        text:'十方星链（苏州）航天科技有限公司北京分公司',
        lng:'116.248758',
        lat:'40.076822',
        span:'北京',
        phone:'010-62488895',
        email:'sfsatlink@sfsatlink.com',
        icon:'北京市海淀区北清路68号用友产业园北区-16F2层',
      },
      //{
       // text:'十方星链(苏州)航天科技有限公司合肥分公司',
       // lng:'117.107344',
       // lat:'31.840116',
       // span:'合肥',
       // phone:'010-62488895',
       // email:'sfsatlink@sfsatlink.com',
       // icon:'安徽省合肥市自由贸易试验区合肥市高新区望江西路900号中安创谷科技园A3A4栋7楼782-1室',
      //},

    ],
      input:'',
      textarea:'',
      mobile:'',
      phone:'',
      name:'',
    };
  },
  mounted () {
    var element=0
    if(this.$route.query.id==1){
       element = this.$refs.lys;
    }
      if (element) {
        setTimeout(() => {
          const rect = element.getBoundingClientRect();
        const distanceToTop = rect.top + window.scrollY; // 计算距离顶部的距离
        this.$bus.$emit("clearKeyword",distanceToTop);
        }, 500);
      }
    },
  methods: {
    addmessage(){
      var that=this
      var data={
        name:this.name,
        phone:this.phone,
        enterpriseName:this.input,
        content:this.textarea,
      }
      lxapi.addmessage(data).then(res=>{
        console.log(res)
        that.$confirm(`提交成功`,'提示',{
          confirmButtonText:'关闭',
          cancelButtonText: "关闭",
          showCancelButton: false,
          type:'success'
         }).then(()=>{
         })
        that.name=''
        that.phone=''
        that.input=''
        that.textarea=''
      }).catch(err=>{
         that.$confirm(err.message,'提示',{
          confirmButtonText:'关闭',
          cancelButtonText: "关闭",
          showCancelButton: false,
          type:'error'
         }).then(()=>{
         })


        // that.$message({
        //       message: ,
        //       type: "error",
        //     });
      })
    },
    spansClick(item,index){
      this.id=index
    },
    sendEmail(email){
      window.location.href = 'mailto:' + email
    },
    sendphone(phone){
      window.location.href = 'tel:' + phone    },
  }
};
</script>

<style scoped lang="scss">
.contact {
 .contact-head{
    display: flex;
    margin-top:50px;
    margin-bottom:50px;
    border:1px solid #c88e5c;
    .contact-head-left{
      width:30%;
      background: #c88e5c;
      color:white;
      dl{
        padding:20px;
      }
      dt{
        text-align: center;
        img{
          width:25px;
        }
      }
      dd{
        margin:0;
        font-size:18px;
        text-align: center;
      }
    }
    .contact-head-right{
      margin:auto;
      margin-left:50px;
      font-size:24px;
      color:#363636;
    }
 }
 .contact-icon{
  cursor: pointer;
  box-shadow: 0 0 4px 4px #ccc;
  padding:20px;
  height:180px;
   span{
    font-weight: 400;
    font-size: 24px;
    margin-left:25px;
   }
   li{
    display: flex;
    p{
      margin-top:5px;
      margin-left:10px;
    }
    img{
      margin-top:5px;
      width:20px;
      height:20px;
      vertical-align: middle;
    }
    color: #343434;
   }
 }
 .contact-head-p{
  text-align: center;
  font-size:100px;
  font-weight: 800;
  position: relative;
  color:#f7f0ec;
  margin-top:50px;
  b{
    position: absolute;
    left:50%;
    top:50%;
    font-size:26px;
    color:black;
    width:120px;
    height:50px;
    display: block;
    margin-left:-50px;
    margin-top:-25px;
    line-height:60px;
  }
}
.contact-message{
  padding:20px;
  background: #f1f4f7;
  display: flex;
  .contact-message-left{
    flex:1;
   margin-right:20px;
  }
  .contact-message-right{
    flex:1;
  }
}
.contact-botton{
  margin-bottom:50px;
  background:#f1f4f7;
  height:70px;
  padding-top:10px;
  text-align: center;
  span{
    font-size: 16px;
    color:white;
    padding:10px 40px;
    background: #c88f5c;
  }
}
}
// 响应式
@media only screen and (max-width: 767px) {

}
</style>
<style>
.el-textarea__inner{
  height:100% !important;
}
</style>
